import * as React from 'react';

import CustomerHeader from '../../../../../Components/CustomerHeader/CustomerHeader';
import { StaticBreadcrumbs } from '../../../../../Partials/Breadcrumbs/StaticBreadcrumbs';
import { OrderHistoryProps } from '../../OrderHistoryProps.csharp';
import { OrderList } from '../OrderList/OrderList';

export default class OrderHistory extends React.Component<OrderHistoryProps> {
    constructor(props: OrderHistoryProps) {
        super(props);
    }

    render() {
        const {
            props: {
                orderUrl,
                orderDetailsUrl,
                customerHeader,
                model: { infoBlock, rxOrderHistoryUrl }
            }
        } = this;

        return (
            <div className="OrderHistory">
                <StaticBreadcrumbs {...customerHeader.breadcrumbs} />

                <div className="OrderHistory__Inner">
                    <CustomerHeader model={customerHeader} />
                    <OrderList orderUrl={orderUrl} orderDetailsUrl={orderDetailsUrl} infoBlock={infoBlock} rxOrderHistoryUrl={rxOrderHistoryUrl} />
                </div>
            </div>
        );
    }
}
